export default function LocationIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="map">
        <path
          id="Vector"
          d="M5 15.7354C2.55699 16.4332 1 17.4888 1 18.6702C1 20.7713 5.92488 22.4747 12 22.4747C18.0751 22.4747 23 20.7713 23 18.6702C23 17.4888 21.443 16.4332 19 15.7354"
          stroke="#1976D2"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          id="location"
          d="M12.0001 1C8.01915 1 4.78007 4.2301 4.78007 8.1955C4.75389 13.996 11.7257 18.8056 12.0001 19C12.0001 19 19.2463 13.996 19.2201 8.2C19.2201 4.2301 15.981 1 12.0001 1Z"
          stroke="#1976D2"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          id="location_2"
          d="M12 11.3C10.2872 11.3 8.9 9.91273 8.9 8.19998C8.9 6.48723 10.2872 5.09998 12 5.09998C13.7127 5.09998 15.1 6.48723 15.1 8.19998C15.1 9.91273 13.7127 11.3 12 11.3Z"
          stroke="#1976D2"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  );
}
